import { dedupeById, getPagination } from '@/utils/helpers';
import {
    FETCH_PRODUCTS,
    FETCH_ACTIVE_PRODUCTS,
    FETCH_PRODUCT,
    CREATE_PRODUCT,
    UPDATE_PRODUCT,
    REMOVE_PRODUCTS,
    FETCH_PRODUCT_STATS,
    FETCH_INVENTORY_STATS,
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    list: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30,
        },
    },

    activeList: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 20,
        },
    },

    // nếu bạn có màn riêng inventory thống kê
    inventoryStats: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 20,
        },
    },

    detail: null,

    createResult: null,
    updateResult: null,
    deleteResult: null,

    statistical: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        /**
         * Danh sách SP (load mới)
         */
        case FETCH_PRODUCTS: {
            const payload = action.payload || {};
            return {
                ...state,
                list: {
                    items: payload.data || [],
                    pagination: getPagination(payload, 30),
                },
            };
        }

        /**
         * Danh sách SP active (có thể dùng cho infinite scroll)
         * => nếu page 1: ghi đè; page >1: nối + dedupe
         */
        case FETCH_ACTIVE_PRODUCTS: {
            const payload = action.payload || {};
            const isFirstPage = parseInt(payload.current_page, 10) === 1;

            const merged = isFirstPage
                ? (payload.data || [])
                : [...(state.activeList.items || []), ...(payload.data || [])];

            return {
                ...state,
                activeList: {
                    items: dedupeById(merged),
                    pagination: getPagination(payload, 20),
                },
            };
        }

        /**
         * Chi tiết SP
         */
        case FETCH_PRODUCT: {
            return {
                ...state,
                detail: action.payload || null,
            };
        }

        /**
         * Tạo SP
         */
        case CREATE_PRODUCT: {
            return {
                ...state,
                createResult: action.payload || null,
                // (tuỳ chọn) push lên đầu list để UI thấy ngay
                list: {
                    ...state.list,
                    items: action.payload ? dedupeById([action.payload, ...(state.list.items || [])]) : (state.list.items || []),
                },
            };
        }

        /**
         * Cập nhật SP
         */
        case UPDATE_PRODUCT: {
            const updated = action.payload || null;

            const updateInArray = (arr = []) => {
                if (!updated?.id) return arr;
                const idx = arr.findIndex((x) => x?.id === updated.id);
                if (idx === -1) return arr;
                const clone = [...arr];
                clone[idx] = updated;
                return clone;
            };

            return {
                ...state,
                updateResult: updated,
                detail: state.detail?.id === updated?.id ? updated : state.detail,
                list: {
                    ...state.list,
                    items: updateInArray(state.list.items || []),
                },
                activeList: {
                    ...state.activeList,
                    items: updateInArray(state.activeList.items || []),
                },
            };
        }

        /**
         * Xoá SP
         */
        case REMOVE_PRODUCTS: {
            const ids = action.payload || [];
            const idSet = new Set(ids);

            const filterOut = (arr = []) => (arr || []).filter((x) => !idSet.has(x?.id));

            return {
                ...state,
                deleteResult: ids,
                list: {
                    ...state.list,
                    items: filterOut(state.list.items || []),
                },
                activeList: {
                    ...state.activeList,
                    items: filterOut(state.activeList.items || []),
                },
            };
        }

        /**
         * Thống kê SP ( /products/statistics )
         */
        case FETCH_PRODUCT_STATS: {
            return {
                ...state,
                statistical: action.payload || null,
            };
        }

        /**
         * Thống kê tồn kho ( /products/statistics/inventory )
         * payload thường dạng: { items: [], pagination: { current_page,total,per_page } }
         */
        case FETCH_INVENTORY_STATS: {
            const payload = action.payload || {};
            return {
                ...state,
                inventoryStats: {
                    items: payload.items || [],
                    pagination: getPagination(payload.pagination || {}, 20),
                },
            };
        }

        default:
            return state;
    }
};